<script setup lang="ts">
  const props = defineProps({
    nameItem: { type: String, default: 'Prueba item' },
  })

  defineEmits(['clicked'])
</script>

<template>
  <div
    class="w-full min-h-2rem max-h-auto p-1 bg-gray-200 hover:bg-gray-300 hover:text-900 flex justify-content-start align-items-center text-center cursor-pointer border-round-lg mr-5 my-2"
    @click="$emit('clicked')"
  >
    <p class="text-700 w-full">
      {{ nameItem }}
    </p>
  </div>
</template>
